import React, { useId } from 'react';

import { Shader, SolidColor, SineWave, WaveDistortion, FilmGrain } from 'shaders/react';

import { shaderIdPrefix } from '../utils/shaderIdPrefix';

type Props = {
  color?: string;
};

export default function BackMidnightFlowing(props: Props) {
  'use memo';

  // Reserved for future use (see commented-out effect below); prefix keeps it exempt from no-unused-vars.
  const { color: _color } = props;
  const uid = shaderIdPrefix(useId());
  /* const highlight = color || '#002F9A';
  const background = adjustLightAndSat(highlight, 0.15, 1); 
  const shadow = addOpacity(background, 0);
  const [speed1, setSpeed1] = useState(-0.1);
  const [speed2, setSpeed2] = useState(0.2);

  useEffect(() => {
    setTimeout(() => {
      setSpeed1(0);
      setSpeed2(0);
    }, 10000); 
  }, [highlight, background, shadow]);*/

  return (
    <Shader
      className="back-midnight-flowing"
      style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0 }}
    >
      <SolidColor id={`${uid}_solid`} color="#000B25" />
      <SineWave
        id={`${uid}_wave_1`}
        amplitude={0.5}
        angle={144}
        blendMode="normal-oklab"
        color="#002F9A"
        frequency={0.4}
        position={{ x: 0.22, y: 0.27 }}
        softness={0.55}
        speed={-0.025}
        thickness={0.72}
      />
      <SineWave
        id={`${uid}_wave_2`}
        amplitude={0.58}
        blendMode="normal-oklch"
        color="#020717"
        frequency={0.6}
        position={{ x: 0.6, y: 0.51 }}
        softness={0.57}
        speed={0.05}
        thickness={0.58}
      />
      <WaveDistortion
        id={`${uid}_distortion`}
        angle={114}
        edges="mirror"
        speed={0.3}
        strength={0.61}
      />
      <FilmGrain id={`${uid}_grain`} opacity={0.36} strength={0.03} />
    </Shader>
  );
}
